import React, {useState, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../features/user";
import { setNavIndex } from "../../features/common";
import { useTranslation } from 'react-i18next'
import { delay, navigateTo } from '../../Helper';

const ProviderMenu = () => {
    const [state, setState] = useState({ show: false, slide: false, homeButtons: false, profileMenu: false });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();


    // useEffect(()=>{
    //     // slideMenu();
    
    //     // eslint-disable-next-line
    // },[]);

    const showMenu = async (show) => {
        if(show) {
            setState({...state, show:true, slide:false});
            await delay(1);
            setState({...state, slide:show, show:show});
        } else {
            setState({...state, slide:false, show:true});
            await delay(300);
            setState({...state, show:show, slide:show});
        }
    }

    const navigateMenuTo = (to, index=0) => {
        if (to !== location.pathname) {
            navigateTo(dispatch, navigate, to, index);
        }
        showMenu(false);
    }

    const toggleHomeButtons = () => {
        setState({...state, homeButtons:!state.homeButtons});
    }

    const toggleProfileMenu = () => {
        setState({...state, profileMenu:!state.profileMenu});
    }

    const openUrlClick = (url) => {
        //navigate("/display-link?url="+url);
           window.open(url, '_blank', 'noopener,noreferrer');
        //   window.open(url, '_self', 'noopener,noreferrer');
    }; 

    const logoutClick = () => {
        dispatch(logout());
        navigate('/start')
    }

    return <>
        {!state.show?<div className="menu-icon pointer-events-initial">
            <img src={'/images/menu/menu.png'} onClick={() => showMenu(true)} className='ml5 mr5 menu-icon' alt=''/>
        </div>:
        <div className="overlay pointer-events-initial" onClick={() => showMenu(false)}>
            <div className={`menu ${state.slide ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
                {/* <div className="ml10 mr10"> */}
                    <div className="menu-row mt30">
                        <div className='font-25 font-bold color-550952'>{t('menu')}</div>
                        <div><img src='/images/menu/back_arrow.png' className='menu-icons' onClick={() => showMenu(false)} alt=''/></div>
                    </div>
                    <div>
                        <img className='width-100' src='/images/menu/divider.png' alt=''/>
                    </div>

                    <div className="menu-row mt10" onClick={() => toggleHomeButtons()}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/home.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('home_page')}</div>
                        </div>
                        <div><img src={`/images/menu/${state.homeButtons?"close":"open"}.png`} className='menu-icons' alt=''/></div>
                    </div>
                    {state.homeButtons && <div className='background-EEE9FF'>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-list')}>
                            <img src='/images/menu/edit.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_provider')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/graphic-list')}>
                            <img src='/images/menu/graphic.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('graphic_provider')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/marketing-list')}>
                            <img src='/images/menu/marketing.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('marketing_provider')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/print-list')}>
                            <img src='/images/menu/print.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('print_provider')}</div>
                        </div>
                    </div>}

                    <div className="menu-row mt10" onClick={() => toggleProfileMenu()}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/profile.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('profile')}</div>
                        </div>
                        <div><img src={`/images/menu/${state.profileMenu?"close":"open"}.png`} className='menu-icons' alt=''/></div>
                    </div>
                    {state.profileMenu && <div className='background-EEE9FF'>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/provider', 1)}>
                            <img src='/images/menu/profile.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('profile')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-provider-profile', 1)}>
                            <img src='/images/menu/edit_profile.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_profile')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-provider-packages', 1)}>
                            <img src='/images/menu/edit_packages.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_packages')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-provider-portfolio', 1)}>
                            <img src='/images/menu/edit_packages.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_portfolio')}</div>
                        </div>
                        <div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-provider-education', 1)}>
                            <img src='/images/menu/edit_packages.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_education')}</div>
                        </div>
                        {/*<div className='sub-menu-row ' onClick={() => navigateMenuTo('/edit-provider-questionnaire', 1)}>
                            <img src='/images/menu/edit_questionnaire.png' className='menu-icons' alt=''/>
                            <div className='font-15 font-bold color-550952'>{t('edit_questionnaire')}</div>
                        </div>*/}
                    </div>}

                    
                    <div className='text-align-end'>
                        <img className='width-80' src='/images/menu/divider.png' alt=''/>
                    </div>

                    <div className="menu-row mt10" onClick={() => navigateMenuTo('/provider-analytics', 1)}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/analytics.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('statistics')}</div>
                        </div>
                        <div><img src='/images/menu/premium_menu.png' className='menu-icons' alt=''/></div>
                    </div>

                    <div className="menu-row mt10" onClick={() => openUrlClick('https://www.kotvot.com/help')}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/help.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('get_help')}</div>
                        </div>
                        <div><img src='/images/menu/next.png' className='menu-icons' alt=''/></div>
                    </div>

                    <div className="menu-row mt10" onClick={() => openUrlClick('https://www.kotvot.com/about-us')}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/info.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('about_us')}</div>
                        </div>
                        <div><img src='/images/menu/next.png' className='menu-icons' alt=''/></div>
                    </div>


                    <div className='text-align-end'>
                        <img className='width-80' src='/images/menu/divider.png' alt=''/>
                    </div>

                    <div className="menu-row mt10" onClick={() => logoutClick()}>
                        <div className='flex align-items-center'>
                            <div className='ml10'><img src='/images/menu/logout.png' className='menu-icons' alt=''/></div>
                            <div className='font-20 font-bold color-550952'>{t('logout')}</div>
                        </div>
                        <div><img src='/images/menu/next.png' className='menu-icons' alt=''/></div>
                    </div>

                    <div className='center-div mt15'><img src='/images/logo_big.png' className='menu-logo' alt=''/></div>

                {/* </div> */}
            </div>    
        </div>}
    </>;
};


export default ProviderMenu;